import { CheckmarkCircle, CloseCircle } from "@raresail/react-ionicons";
import { isValidElement, useEffect } from "react";
import { PRIMARY_LIGHT } from "../../constants/colors";
import useGet from "../../hooks/common/useGet";
import { listHooks } from "../../hooks/handlers/registerHooks";
import { stringify } from "../../utils/helpers";
import { SimpleLoader } from "../common/Loader";
import { BottomSheetTitle, EmptyField, EmptyView } from "../elements/Elements";

export const DetailsView = ({
  data = {},
  title,
  dismiss,
  id,
  source,
  footer,
  state,
  showTitle = true,
  enablePadding = true,
}: {
  id?: string | any;
  source?: string | any;
  data?: any;
  title?: string;
  dismiss?: string;
  footer?: any;
  state?: any;
  showTitle?: boolean;
  enablePadding?: boolean;
}) => {
  const hook = listHooks?.[source];
  const { api, viewData }: any = hook ? hook({}) : {};

  const { loadData, data: details, loading } = useGet();

  useEffect(() => {
    if (api && id) {
      loadData({ api, id });
    }
  }, [id, api]);

  const renderValue = (value: any) => {
    if (value === null || value === undefined) {
      return <EmptyField />;
    }
    if (typeof value == "string" || typeof value == "number") {
      return stringify(value.toString());
    }
    if (typeof value == "boolean") {
      return (
        <div className="flexNullCenter gap5">
          <div className="font16" style={{ marginTop: 3 }}>
            {value ? (
              <CheckmarkCircle color="green" />
            ) : (
              <CloseCircle color="red" />
            )}
          </div>
          <div>{value ? "Yes" : "No"}</div>
        </div>
      );
    }
    if (isValidElement(value)) {
      return value; // component
    }
    if (typeof value == "object") {
      return <div className="p5">{renderFields(value || {})}</div>;
    }
    return <EmptyField />;
  };

  const renderFields = (data: any) => {
    return Object?.entries(data)?.map(([key, value], i) => {
      return (
        <div
          key={i}
          style={{ minHeight: 38, padding: "0 10px" }}
          className={`flexSpaceCenter gap10 ${i & 1 ? "" : "lightBg"}`}
        >
          <div className="font13 semiBold textDark capitalize">
            {stringify(key)}
          </div>
          <div className="font13 textDark capitalize textEnd">
            {renderValue(value)}
          </div>
        </div>
      );
    });
  };

  // render display data
  const displayData: any = viewData ? viewData(details || data) : data;

  return (
    <div className={`flexColumn gap15 ${enablePadding ? "p15" : ""}`}>
      {/* TITLE */}
      {showTitle && (
        <BottomSheetTitle dismiss={dismiss}>{title}</BottomSheetTitle>
      )}

      {/* DATA */}
      {loading ? (
        <SimpleLoader />
      ) : Object?.keys(displayData)?.length > 0 ? (
        <div
          className="flexColumn r10 hidden"
          style={{ border: `1px solid ${PRIMARY_LIGHT}` }}
        >
          {renderFields(displayData)}
        </div>
      ) : (
        <EmptyView />
      )}

      {/* FOOTER */}
      {footer && footer({ data: displayData, dismiss, state, details })}
    </div>
  );
};
